import React from 'react';
import Icon from '../../../components/AppIcon';

import { cn } from '../../../utils/cn';

const QuietHoursConfig = ({ enabled, startTime, endTime, onToggle, onStartTimeChange, onEndTimeChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Moon" size={20} className="text-primary" />
          <h2 className="font-heading text-xl font-semibold text-foreground">
            Quiet Hours
          </h2>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          onClick={onToggle}
          className={cn(
            "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            enabled ? "bg-primary" : "bg-input"
          )}
        >
          <span
            className={cn(
              "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
              enabled ? "translate-x-6" : "translate-x-1"
            )}
          />
        </button>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        Set specific hours when notifications should be silenced. You won't receive any alerts during this time.
      </p>

      {enabled && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-muted/30 rounded-lg">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Start Time
            </label>
            <div className="relative">
              <input
                type="time"
                value={startTime}
                onChange={(e) => onStartTimeChange(e?.target?.value)}
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              End Time
            </label>
            <div className="relative">
              <input
                type="time"
                value={endTime}
                onChange={(e) => onEndTimeChange(e?.target?.value)}
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              />
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <Icon name="Info" size={16} className="mt-0.5 flex-shrink-0" />
              <p>
                Quiet hours are based on your local timezone. Notifications will resume automatically after the end time.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuietHoursConfig;